import { toast } from "react-toastify";

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Copied!");
  } catch (err) {
    toast.error("Failed to copy: ", err?.message);
  }
};

export const limitDecimalsToTwo = (value) => {
  if (value === undefined || value === null) {
    return "";
  }
  let rawValue = value.toString().replace(/[^0-9.]/g, "");
  const parts = rawValue.split(".");
  if (parts.length > 1) {
    rawValue = `${parts[0]  }.${  parts[1].slice(0, 2)}`;
  }
  return rawValue;
};

export const formatAmountWithCommas = (value) => {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  const rawValue = value.toString().replace(/[^0-9.]/g, "");

  const parts = rawValue.split(".");
  // Add commas to the integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (parts.length > 1) {
    return `${parts[0]  }.${  parts[1].slice(0, 2)}`;
  }
  return parts[0];
};
